module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation8.e529e12b.png";